import idx from 'idx'
import { withFormik } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'

import { isEqual } from 'utils/misc'
import { required, coordinate, withinMinLength } from 'utils/validation'
import { FORM_ACTION_ERROR_STATUS, FORM_PROGRESS_STATUS, FORM_SUBMIT_STATUS } from 'constants/form'

import * as popoverModule from 'modules/popover'

export default compose(
  connect(
    (state) => {
      return {
        organisation: idx(state, _ => _.organisation.selected),
        progressUpdateTrap: idx(state, _ => _.progress.updateTrap)
      }
    },
    (dispatch) => {
      const actions = {
        ...popoverModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withFormik({
    mapPropsToValues: ({ data }) => ({ name: data.trapName || data.serial || '', latitude: data.latitude, longitude: data.longitude }),
    validate: ({ name, latitude, longitude }) => {
      const errors = {}
      
      if (required(name)) {
        errors.name = 'Please enter a valid trap name'
      } else if (!withinMinLength(3, name)) {
        errors.name = 'Name must be 3 or more characters long'
      }
      if (required(latitude) || coordinate(latitude)) {
        errors.latitude = 'Please enter a valid latitude'
      }
      if (required(longitude) || coordinate(longitude)) {
        errors.longitude = 'Please enter a valid longitude'
      }

      return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)
      const initialValues = { 
        name: props.data.trapName, 
        latitude: parseFloat(props.data.latitude), 
        longitude: parseFloat(props.data.longitude)
      }

      const newValues = {
        ...values,
        name: values.name === props.data.serial && !props.data.trapName ? props.data.trapName : values.name
      }

      if (!isEqual(newValues, initialValues)) {
        props.data.onUpdate(values)
      } else {
        props.handleClose()
      }
    },
  }),
  withHandlers({
    handleFieldChange: props => (event) => {
      props.setStatus(FORM_PROGRESS_STATUS)
      props.handleChange(event)
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    handleTrapDeleteClick: props => () => {
      props.data.onDelete()
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        progressUpdateTrap, apiCallError, setStatus, setSubmitting
      } = this.props
      // trigger when error occured during login
      if (prevProps.apiCallError !== apiCallError && apiCallError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }

      if (prevProps.progressUpdateTrap !== progressUpdateTrap && progressUpdateTrap.hasError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }
    },
  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/EditTrapForm/EditTrapForm.enhancer.js